export const Awwmageddon={
    // Header
    title:"Awwmageddon",
    subtitle:"Unreal Engine 5 | 3D",
    genre:"Arcade Destruction",

    //Hero
    poster:"/Games/Awwmageddon/AwwMageddon-Poster.png",
    releaseDate:"May 2025",
    studioName:"",
    teamSize:"4 Programmers & 5 Artists",
    platforms:"PC",
    responsiblities:[
        "Developed AI for Kaijuwu",
        "Developed Feather and Yarnball 'cat toys'",
    ],
    engine:"Unreal Engine 5 using Blueprints",
    projectLength:"~4 Months",

    //Description
    desc:[
        `Assume the position of a pair of genius alien overlords experimenting with a dangerous monster!`,        
        `In the game, you’ll hover around the Kaijuwu using cat toys to guide the monster around a city, reveling as it destroys everything in its path.`,
        ``
    ],
    img:[
        "/Games/Awwmageddon/AwwMageddon-Menu.png", "/Games/Awwmageddon/Awwmageddon-Lazer.png", "/Games/Awwmageddon/Awwmageddon-Points.png"
    ],
    contributions:[
        `Acted as Scrum Master, coordinating meetings and utilizing Microsoft Tasks for Agile development.`,
        `Designed and implemented an AI behavior tree using Blueprints to enhance gameplay interactions and depth.`,
        `Partnered with a multidisciplinary team of developers and artists to produce a cohesive gameplay experience.`,
    ],


    //Home Screen Hero
    thumbnail:"./Thumbnails/AwwMag_Thumbnail.png",
    shortDesc:`3D city destruction game made in Unreal Engine 5 utlizing the AI behavior tree.\n\nAttempt to control the (incredibly) cute and (incredibly) destructive Kaijuwu to destroy the city!`,
    badge:"./Project Badges/unreal-5-blueprints.svg",
    url:"/projects/Awwmageddon",
    type:"Games",


    trailers:[
        "https://www.youtube.com/embed/e-K8TPjRHVQ?si=7TDPStkwjSZAlw2T"
    ],



    awards:"yes",
    awardImg:["/Games/Awwmageddon/AwwMageddon_BestArt.png", "/Games/Awwmageddon/AwwMageddon_AudienceChoice.png"
    ],
    downloadable:".",
    credits:".",
    
    //Links
    githubURL:"",
    itchioURL:"https://claw-and-order-games.itch.io/awwmageddon",
    itchioEmbedURL:"https://itch.io/embed/3161137?linkback=true&amp;link_color=52be34&amp;border_color=8e00de",
    steamURL:"",
}